import SlotModel from './slot.model';

export default class DataSlotModel extends SlotModel {

  public isInCart: boolean;
  public _computedFields: any = {
    gadgetsList: <any>[],
    selectedAddons: <any>[],
  };

  constructor(
    bundle: any,
    ordinal: number,
    isInCart: boolean,
    title: string,
  ) {
    super(bundle, ordinal, null);

    this.title = this.summaryTitle = title;
    this.isInCart = isInCart;
  }
}
